export default function getBrightness(rgb) {
  const {r, g, b} = rgb;
  return Math.sqrt(0.299 * (r * r) + 0.587 * (g * g) + 0.114 * (b * b));
}
